import React, {Component} from 'react';
import {Col} from "reactstrap";
import Loading from "react-loading-animation";
import moment from "moment";
import ProfilePic from "../../../../../components/ProfilePic";

import messaging_utility from "../../../../../util/messaging/utility";
import "./index.css";
import UserListItem from "../../../../../components/messaging/user-list-item";
import InfiniteScroll from "react-infinite-scroll-component";

import NewChatSearch from "../../../../../components/messaging/new-chat-search";
import strings from "../../../../../util/strings";
import EmptyComponent from "../../../../../components/empty";

class ListOfMessages extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        }

    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }

    render() {
        return (
            <Col md="4">
                <div className="display-flex-justify-content-space-between-align-items-center">
                    {
                        (this.props.broadcaster || this.props.user) &&
                        <ProfilePic
                            profile_pic={this.props.user_type === "broadcaster" ? this.props.broadcaster.profile_pic : this.props.user.profile_pic}
                            user_type={this.props.user_type}
                            is_verified={this.props.user_type === "broadcaster" ? this.props.broadcaster.is_verified : 0}
                        />
                    }

                    <div className="new-chat" onClick={this.props.setNewChatModalOpen}>
                        New chat
                    </div>
                </div>

                <NewChatSearch
                    search={(searchText) => {
                        console.log("ListOfMessages >> searchText = " + searchText)
                        this.setState({
                            searchText
                        })
                        this.props.searchInListOfChannels(searchText)
                    }}/>

                {
                    this.props.groupChannels && this.props.groupChannels.length === 0 && this.state.searchText.length > 0 &&
                    <EmptyComponent
                        img={strings.messaging.no_search_result.image}
                        title={strings.messaging.no_search_result.title}
                        description={strings.messaging.no_search_result.description}
                        btnAction={this.newChat}
                        btnText={""}
                    />
                }
                <InfiniteScroll
                    className="infinite-scroll-component"
                    dataLength={1}
                    next={() => {
                    }}
                    hasMore={false}
                    loader={<Loading/>}
                    endMessage={<span/>}>

                    {
                        this.props.groupChannels && this.props.groupChannels.map((channel) => {

                            let member = messaging_utility.retrieveMemberDetails(this.props,channel);
                            if(member.length === 1){
                                member = member[0];
                                let dateTime = moment(channel.createdAt).fromNow();

                                if(channel.lastMessage && channel.lastMessage.hasOwnProperty("createdAt")){
                                    dateTime = moment(channel.lastMessage.createdAt).fromNow();
                                }else if(channel.myLastRead){
                                    dateTime = moment(channel.myLastRead).fromNow();
                                }

                                if (member.isActive && !member.isBlockedByMe) {
                                    return (
                                        <UserListItem
                                            key={`${channel.url}`}
                                            isMuted={member.isMuted}
                                            username={member.nickname}
                                            status={member.connectionStatus === "online" ? 1 : 0}
                                            profile_pic={member.profileUrl}
                                            unreadCount={channel.unreadMessageCount}
                                            action={(item) => {
                                                console.log("ListOfMessages >> clicked on channel", channel)
                                                this.props.setSelectedChannel(channel)
                                            }}
                                            message={channel.lastMessage && channel.lastMessage.hasOwnProperty("message") ? channel.lastMessage.message : ""}
                                            item={member}
                                            datetime={dateTime}/>
                                    )
                                }
                            }
                        })
                    }

                </InfiniteScroll>
            </Col>
        );
    }
}


export default ListOfMessages;
